import { createSelector } from '@reduxjs/toolkit';
import { calcPaginationState } from 'utils/service';
import { AppState } from '../index';

const selectState = (state: AppState) => state.labels;

export const selectLabelsStatuses = createSelector(selectState, ({ isLoading, error, isInit }) => {
  return { isLoading, error, isInit };
});
export const selectLabelsData = createSelector(selectState, ({ data }) => {
  return data;
});
export const selectLabelsFilters = createSelector(selectState, ({ filters }) => {
  return filters;
});
export const selectLabelsPagination = createSelector(selectState, ({ pagination }) => {
  return calcPaginationState(pagination);
});
export const selectLabelsOrderBy = createSelector(selectState, ({ orderBy }) => {
  return orderBy;
});
